import React from 'react'
import { Link } from 'react-router-dom'
import { FaInstagram, FaFacebook } from "react-icons/fa";
function MainFooter() {
  return (
    <div className="footer-section-main">
        <div className="content-section">
        <div className="container">
            <div className="row">
                <div className="col-md-4">
                <div className="foot-widget foot-address">
                <h3>Address</h3>
                    <div className="sm-address">
                    12 Pretoria Road <br/>
                    Kempton Place<br/>
                    Kempton Park<br/>
                    1619
                    </div>
                    <h3>Payment Options</h3>
                    <p>
                        <img className="img-small image-task " src="https://stephensonadventures.co.za/wp-content/uploads/2019/09/payment-options.png" alt="Stephenson Payment Options" width="300" height="48" /></p>
                    <h3>Socials</h3>
                    <p>
                        <Link target="_blank" to="https://web.facebook.com/Stephensonadventures/?_rdc=1&_rdr">
                            <FaFacebook />
                        </Link> 
                        <span className="bar">|</span> 
                        <Link target="_blank" to="https://www.instagram.com/stephenson_adventures/?hl=en">
                            <FaInstagram />
                        </Link>
                    </p>

                </div>
                </div>
                <div className="col-md-4">
                    <div className="foot-widget foot-info">
                    
                    <h3>For more information</h3>
                            <p className="tb-info"><strong>Email</strong>:<br/>
                            
                            <Link href="mailto:info@stephensonadventures.co.za">info@stephensonadventures.co.za</Link>
                            </p>
                            <p className="tb-info"><strong>Bookings</strong>: <Link href="mailto:bookings@stephensonadventures.co.za">bookings@stephensonadventures.co.za<br/>
                            </Link></p>
                            <p className="tb-info"><strong>Telephone/ Whatsapp</strong>: <Link href="tel:+27 789304295">+27 78 930 4295</Link> / <Link href="tel:+27 679332005">+27 679332005</Link>
                            </p>
                            <p className="tb-info"><strong>Email</strong>: <Link href="mailto:stephenson@stephensonadventures.co.za">stephenson@stephensonadventures.co.za<br/>
                            </Link></p>
                        </div>
                   
               </div>
                <div className="col-md-4">
                    <div className="foot-widget foot-widget">
                    <h3>Trip Advisor</h3>
                  
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div className="bottom-content black-back"> ALL RIGHTS RESERVED</div>
    </div>
  )
}

export default MainFooter